// @noflow
import { last, range } from 'lodash/fp';

export const DEFAULT_FONT = 'Bariol, Arial, sans-serif';

const getColour = ({ aboveColor, belowColor, midTemp }) => temperature =>
    temperature <= midTemp ? belowColor : aboveColor;

const formatTemperatureToObj = (temperature, frostProtectionValue) =>
    temperature
        .toString()
        .split('.')
        .reduce((agg, val) => {
            if (frostProtectionValue && parseInt(val, 10) === frostProtectionValue) {
                return [{ text: `${val}`, coef: 1 }, { text: 'N', coef: 0.7, font: 'HiveGeneralIcons' }];
            } else if (agg.length) {
                const prev = last(agg);
                return [{ text: prev.text.slice(0, -1), coef: prev.coef }, { text: `.${val}°`, coef: 0.5 }];
            } else {
                return [{ text: `${val}°`, coef: 1 }];
            }
        }, []);

const defineRangeAndFormat = ({ interval, maxTemp, minTemp, formatFn, frostProtectionValue = null }) => {
    const total = (maxTemp - minTemp) / interval + 1;
    return range(0, total).reduce((agg, _, index) => {
        const temperature = maxTemp - index * interval;
        const value = formatFn(temperature, frostProtectionValue);
        return [...agg, value];
    }, []);
};

export const defineRangeValues = ({ interval, frostProtectionValue, maxTemp, minTemp }) =>
    defineRangeAndFormat({
        interval,
        maxTemp,
        minTemp,
        formatFn: formatTemperatureToObj,
        frostProtectionValue
    });

export const defineRangeColours = ({ aboveColor, belowColor, interval, maxTemp, midTemp, minTemp }) =>
    defineRangeAndFormat({
        interval,
        maxTemp,
        minTemp,
        formatFn: getColour({ aboveColor, belowColor, midTemp })
    });

export const getIndexFromTemp = ({ interval, maxTemp, minTemp, temp }) => {
    const currentValue = temp ? Math.max(Math.min(temp, maxTemp), minTemp) : minTemp;
    return Math.round((maxTemp - currentValue) / interval);
};

export const getTempFromIndex = ({ maxTemp, interval, index }) => maxTemp - index * interval;



// WEBPACK FOOTER //
// ./src/components/widgets/temperature-spinner/utils.js